<template>
  <v-dialog max-width="1200px" v-model="show">
    <v-form v-model="valid">
      <v-card>
        <v-card-title>配送パターン選択編集ポップアップ</v-card-title>
        <v-card-actions v-show="for600">
          <v-btn
            :disabled="!canSave || !valid"
            @click="choice"
            color="primary"
            v-permit.SHARP_PSD_SAVE
            >{{ $t("app.buttons.save") }}</v-btn
          >
          <v-btn
            :disabled="!canTempSave || !valid"
            @click="choice"
            color="success"
            v-permit.SHARP_PSD_TEMPORARY_SAVE
            >一時データ保存</v-btn
          >
          <v-btn
            :disabled="!canSaveAndSelect || !valid"
            @click="saveAndChoice"
            color="warning"
            v-permit.SHARP_PSD_LOGIN
            >テーブル登録</v-btn
          >
          <v-btn @click="show = false">{{ $t("app.buttons.back") }}</v-btn>
        </v-card-actions>
        <v-card-actions v-show="for800">
          <v-btn
            :disabled="!canSave || !valid"
            @click="choice"
            color="primary"
            v-permit.SHARP_DPRD_SAVE
            >{{ $t("app.buttons.save") }}</v-btn
          >
          <v-btn
            :disabled="!canTempSave || !valid"
            @click="choice"
            color="success"
            v-permit.SHARP_DPRD_TEMPORARY_SAVE
            >一時データ保存</v-btn
          >
          <v-btn
            :disabled="!canSaveAndSelect || !valid"
            @click="saveAndChoice"
            color="warning"
            v-permit.SHARP_DPRD_LOGIN
            >テーブル登録</v-btn
          >
          <v-btn @click="show = false">{{ $t("app.buttons.back") }}</v-btn>
        </v-card-actions>
        <v-card-text>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12>
                <v-autocomplete
                  :items="pattern"
                  clearable
                  item-text="name"
                  item-value="code"
                  label="配送パターン"
                  v-model="patternCode"
                />
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  :disabled="disabled"
                  label="Code"
                  v-model="form.code"
                />
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  :disabled="disabled"
                  label="Pattern Name"
                  v-model="form.name"
                />
              </v-flex>
              <v-flex xs6>
                <remote-autocomplete
                  :rules="[(v) => !!v || `発地 is required`]"
                  :disabled="disabled"
                  clearable
                  key="port"
                  label="発地港口"
                  url="ports/kv"
                  v-if="form.departureType == 'PORT'"
                  v-model="form.departurePortCode"
                />
              </v-flex>
              <v-flex xs2>
                <remote-select
                  :disabled="disabled || !canEditDeparture"
                  :filter="(i) => i.isDevan"
                  clearable
                  item-text="code"
                  item-value="id"
                  label="発地作業"
                  url="charge-item-sub-type"
                  v-model="form.departureWorkId"
                />
              </v-flex>
              <v-flex xs4>
                <remote-autocomplete
                  :rules="[(v) => !!v || `作業業者 is required`]"
                  :disabled="
                    disabled || !canEditDeparture || !form.departureWorkId
                  "
                  label="作業業者"
                  url="companies/devan/kv"
                  v-if="canEditDeparture && form.departureWorkId"
                  v-model="form.departureSupplierId"
                />
              </v-flex>
              <v-flex xs4>
                <remote-autocomplete
                  :rules="[(v) => !!v || `配送業者１ is required`]"
                  :disabled="disabled"
                  label="配送業者１"
                  url="companies/transport/kv"
                  v-model="form.delivery1Id"
                ></remote-autocomplete>
              </v-flex>

              <v-flex xs4>
                <remote-select
                  :rules="[(v) => !!v || `搬送サービス１ is required`]"
                  :disabled="disabled"
                  :filter="(p) => p.isDelivery"
                  item-text="ja_JP"
                  item-value="id"
                  label="搬送サービス１"
                  url="charge-item-sub-type"
                  v-model="form.deliveryModel1Id"
                />
              </v-flex>
              <v-flex xs4>
                <remote-select
                  :disabled="disabled"
                  :rules="[(v) => v != null || `必須項目`]"
                  label="Special"
                  url="delivery-specials/kv"
                  v-if="
                    isDrake(form.deliveryModel1Id) ||
                    isCharter(form.deliveryModel1Id)
                  "
                  v-model="form.deliverySpecial1Id"
                />
              </v-flex>
              <v-flex xs6>
                <remote-autocomplete
                  :disabled="disabled"
                  label="経由場所"
                  url="warehouses/sjl-kv"
                  v-model="form.transitWarehouseId"
                />
              </v-flex>
              <v-flex xs2>
                <remote-select
                  v-if="form.transitWarehouseId"
                  :disabled="disabled || !canEditTransit"
                  :filter="(i) => i.isDevan"
                  clearable
                  item-text="code"
                  item-value="id"
                  label="経由作業"
                  url="charge-item-sub-type"
                  v-model="form.transitWorkId"
                />
              </v-flex>
              <v-flex xs4>
                <!-- :disabled="disabled  || !canEditTransit || !form.transitWorkId" -->
                <remote-autocomplete
                  :rules="[(v) => !!v || `作業業者 is required`]"
                  :disabled="disabled"
                  label="作業業者"
                  url="companies/devan/kv"
                  v-if="
                    canEditTransit &&
                    form.transitWorkId &&
                    form.transitWarehouseId
                  "
                  v-model="form.transitSupplierId"
                />
              </v-flex>
              <v-flex xs4>
                <remote-autocomplete
                  :rules="
                    form.transitWarehouseId
                      ? [(v) => !!v || `配送業者2 is required`]
                      : []
                  "
                  :disabled="!form.transitWarehouseId || disabled"
                  label="配送業者2"
                  url="companies/transport/kv"
                  v-model="form.delivery2Id"
                />
              </v-flex>

              <v-flex xs4>
                <remote-select
                  :rules="
                    form.transitWarehouseId
                      ? [(v) => !!v || `搬送サービス2 is required`]
                      : []
                  "
                  :disabled="!form.transitWarehouseId || disabled"
                  :filter="(p) => p.isDelivery"
                  item-text="ja_JP"
                  item-value="id"
                  label="搬送サービス2"
                  url="charge-item-sub-type"
                  v-model="form.deliveryModel2Id"
                />
              </v-flex>
              <v-flex xs4>
                <remote-select
                  :disabled="!form.transitWarehouseId || disabled"
                  :rules="[(v) => v != null || `必須項目`]"
                  label="Special"
                  url="delivery-specials/kv"
                  v-if="
                    isDrake(form.deliveryModel2Id) ||
                    isCharter(form.deliveryModel2Id)
                  "
                  v-model="form.deliverySpecial2Id"
                />
              </v-flex>
              <v-flex xs6>
                <remote-autocomplete
                  :rules="[(v) => v != null || `必須項目`]"
                  :disabled="disabled"
                  label="SJL納入場所"
                  url="warehouses/kv"
                  v-model="form.destinationWarehouseId"
                />
              </v-flex>
              <v-flex xs2>
                <remote-select
                  :disabled="disabled || !canEditDestination"
                  :filter="(i) => i.isDevan"
                  clearable
                  item-text="code"
                  item-value="id"
                  label="納入作業"
                  url="charge-item-sub-type"
                  v-model="form.destinationWorkId"
                />
              </v-flex>
              <v-flex xs4>
                <!-- :disabled="disabled  || !canEditDestination || !form.destinationWorkId" -->
                <remote-select
                  :rules="[(v) => !!v || `作業業者 is required`]"
                  class="ml-1 mr-2"
                  label="作業業者"
                  url="companies/devan/kv"
                  v-if="
                    !disabled && canEditDestination && form.destinationWorkId
                  "
                  v-model="form.destinationSupplierId"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  props: ["detail"],
  data() {
    return {
      // url: `patterns/all?destinationWarehouseId=${this.detail.sjlWarehouseId}?departureType=port&departure=${this.detail.dischargePortCode}`,
      pattern: [],
      valid: false,
      show: false,
      patternCode: null,
      form: {
        code: null,
        departureType: "PORT",
      },
      resolve: null,
      reject: null,
      errors: {
        CODE_EXISTS: "当該CDは既に存在しています。",
      },
    };
  },
  computed: {
    url() {
      return `patterns/all?destinationWarehouseId=${
        this.detail.sjlWarehouseId
      }&departureType=port&departure=${
        this.detail.dischargePortCode
      }&start=${this.$today()}&end=2999-12-31`;
    },
    for600() {
      return this.$route.path.indexOf("0601") !== -1;
    },
    for800() {
      return this.$route.path.indexOf("0801") !== -1;
    },
    disabled() {
      return !!this.patternCode;
    },
    canSave() {
      return !!this.patternCode;
    },
    canTempSave() {
      return !this.patternCode && !this.form.code;
    },
    canSaveAndSelect() {
      return !this.canSave && !this.canTempSave;
    },
    canEditDeparture() {
      return !this.form.transitWorkId && !this.form.destinationWorkId;
    },
    canEditTransit() {
      return !this.form.departureWorkId && !this.form.destinationWorkId;
    },
    canEditDestination() {
      return !this.form.departureWorkId && !this.form.transitWorkId;
    },
  },
  created() {},
  watch: {
    patternCode(val) {
      if (val == null) {
        this.form = { departureType: "PORT" };
      } else {
        this.loadByCode(val);
      }
    },
    "form.departureWorkId": function (val) {
      if (!val) {
        this.$set(this.form, "departureSupplierId", null);
      }
    },
    "form.transitWorkId": function (val) {
      if (!val) {
        this.$set(this.form, "transitSupplierId", null);
      }
    },
    "form.destinationWorkId": function (val) {
      if (!val) {
        this.$set(this.form, "destinationSupplierId", null);
      }
    },
    "detail.sjlWarehouseId"() {
      this.refreshPattern();
    },
    "form.transitWarehouseId": function (newVal) {
      if (!newVal) {
        this.form.delivery2Id = null;
        this.form.deliveryModel2 = null;
        this.$set(this.form, "transitWorkId", null);
        this.$set(this.form, "transitSupplierId", null);
      }
    },
  },
  methods: {
    isCharter(deliveryModelId) {
      return deliveryModelId == "CHARGE_ITEM_SUB_TYPE-CHARTER";
    },
    isDrake(deliveryModelId) {
      return deliveryModelId == "CHARGE_ITEM_SUB_TYPE-DRAKE";
    },
    refreshPattern() {
      if (this.detail.sjlWarehouseId != null) {
        this.$http
          .get(
            `patterns/all?destinationWarehouseId=${
              this.detail.sjlWarehouseId
            }&departureType=port&departure=${
              this.detail.dischargePortCode
            }&start=${this.$today()}&end=2999-12-31`
          )
          .then((res) => {
            this.pattern = [...res.data];
          });
      }
    },
    remove() {},
    loadByCode(code) {
      this.$http.get(`/patterns/${code}`).then((res) => {
        this.form = { ...this.form, ...res.data };
        this.$set(this.form, "departureType", "PORT");

        this.form.departurePortCode = res.data.departurePortCode;
        console.log(this.form.departurePortCode);
      });
    },
    isChoiceLegal() {
      return this.detail.sjlWarehouseId === this.form.destinationWarehouseId;
    },
    saveAndChoice() {
      if (!this.isChoiceLegal()) {
        this.$confirm({
          content:
            "設定されている配送パターンのSJL納入場所が一致していませんが、このまま進みますか。",
          action: "確定",
        })
          .then(() => {
            return this.doSaveAndChoice();
          })
          .catch(() => {});
      } else {
        this.doSaveAndChoice();
      }
    },
    choice() {
      if (!this.isChoiceLegal()) {
        this.$confirm({
          content:
            "設定されている配送パターンのSJL納入場所が一致していませんが、このまま進みますか。？",
          action: "確定",
        })
          .then(() => {
            return this.doChoice();
          })
          .catch(() => {});
      } else {
        this.doChoice();
      }
    },

    doSaveAndChoice() {
      return this.$http
        .post("/patterns", this.form)
        .then(() => {
          this.doChoice();
          this.refreshPattern();
        })
        .catch((err) => {
          this.$showError(err);
        });
    },
    doChoice() {
      if (
        !this.detail.isFCL &&
        (this.form.departureWorkId != null ||
          this.form.transitWorkId != null ||
          this.form.destinationWorkId != null)
      ) {
        this.$message("", "LCL、Airの場合デバン業者を設定しないでください。");
      } else {
        this.resolve(this.form);
        this.show = false;
      }
    },
    popup(patternCode) {
      this.patternCode = patternCode;
      this.form.code = patternCode;
      if (patternCode) {
        this.loadByCode(patternCode);
      }
      this.show = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    checkTransitWarehouse() {
      this.$http.post("");
    },
  },
};
</script>

// this.$confirm({ content: this.$t('app.messages.sendConfirm') })